import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/numberListTableStyle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableHeader from 'components/TableHeader/TableHeader';
import { SingleAccount } from 'utils/api/models/accounts/singleAccount';
import { capitalize } from 'utils/converters/capitalize';
import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { encode } from 'utils/crypto/crypto';
import { translate } from 'components/Translation';
import { BodyM, BodyMBold } from 'components/Typography/Typography';

// @ts-ignore
const useStyle = makeStyles(styles);

export interface ISelectedAccount {
	name: string;
	id: string | null;
}

interface INumberListTableProps {
	accounts: { accountName: string; accountId: string }[];
	setAccount: React.Dispatch<React.SetStateAction<ISelectedAccount | null>>;
	selectedAccount: ISelectedAccount | null;
	data: any[];
	setSearchInputValue: React.Dispatch<React.SetStateAction<string>>;
	searchInputValue: string;
	loading: boolean;
}

const NumberListTable = (props: INumberListTableProps) => {
	const { accounts, setAccount, setSearchInputValue, searchInputValue, data } = props;

	const classes = useStyle();
	const [shortAccountsResponse, setShortAccountsResponse] = useState<any[]>([]);

	useEffect(() => {
		if (accounts.length === 1) {
			setAccount({
				name: accounts[0].accountName,
				id: accounts[0].accountId,
			});
		}
		// eslint-disable-next-line
	}, [accounts]);

	const serviceType = (number: SingleAccount): string => {
		const { accountType, billingType } = number;
		if (accountType === 'INTERNET') {
			return 'FBB';
		}
		if (accountType === 'FIX') {
			return 'Fixed Line';
		}
		return `${capitalize(accountType)} ${capitalize(billingType)}`;
	};

	useEffect(() => {
		if (data) {
			setShortAccountsResponse(_.slice(data, 0, 5));
		}
	}, [data]);

	const history = useHistory();

	return (
		<>
			<div className={classes.textWrapper}>
				<BodyM disableMargin color="secondary-light">
					{translate('shortcuts.admin.on.the.go.description')}
				</BodyM>
			</div>
			<div className={classes.searchWrapper}>
				<TableHeader
					label={translate('search')}
					setSearchInputValue={setSearchInputValue}
					searchInputValue={searchInputValue}
				/>
			</div>
			<TableContainer className={classes.tableContainer}>
				<Table className={classes.tableStyle} aria-label="simple table">
					<TableHead className={classes.tableHeadStyle}>
						<TableRow>
							<TableCell className={classes.tableCellStyle} align="left">
								Number
							</TableCell>
							<TableCell className={classes.tableCellStyle} align="left">
								Login
							</TableCell>
							<TableCell className={classes.tableCellStyle} align="left">
								Service Type
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{shortAccountsResponse.map((account) => (
							<TableRow
								key={account.id}
								onClick={() => {
									history.push(
										`/shortcuts/postpaid-services/${encode(account.accountNum)}/${
											account.bAccountId
										}/${account.accountType}/${account.billingType}/${account.upAccountId}/${
											account.accountId
										}`
									);
								}}
							>
								<TableCell className={classes.tableCellStyle} component="th" scope="row" align="left">
									<CallOutlinedIcon className={classes.phoneIcon}></CallOutlinedIcon>
									<BodyMBold disableMargin color="secondary-light">
										{account.accountNum}
									</BodyMBold>
								</TableCell>
								<TableCell className={classes.tableCellStyle} align="left">
									<BodyM disableMargin color="secondary-light">
										{account?.login || translate('numbers.details.notAssigned')}
									</BodyM>
								</TableCell>
								<TableCell className={classes.tableCellStyle} align="left">
									<BodyM disableMargin color="secondary-light">
										{serviceType(account)}
									</BodyM>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};

export default NumberListTable;
